import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';

type InsightsCardProps = {
  category: string;
  title: string;
  description: string;
  image: string;
  link: string;

  index: number;
};
const InsightsCard = ({ category, title, description, image, link, index }: InsightsCardProps) => {
  function truncateText(text: string, maxLength: number): string {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  }

  return (
    <div className="max-w-md rounded-[15px] overflow-hidden shadow-lg text-white" style={{ border: '1px solid rgba(122, 122, 122, 0.31)' }}>
      {/* Image section */}
      <div className="w-full overflow-hidden relative ">
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover' // fills container and crops if needed
          }}
        />
      </div>

      <div className="p-6 flex flex-col justify-between gap-6">
        <div className="mb-1">
          <Box
            sx={{
              backgroundColor: '#2F3030',
              color: 'rgb(201, 201, 201)',

              fontSize: '0.875rem',
              fontWeight: 500,
              px: 2,
              py: 1,
              borderRadius: '9999px',
              display: 'inline-block'
            }}
          >
            {category}
          </Box>
        </div>

        <Typography component="h2" sx={{ fontSize: '20px', fontWeight: 400, color: '#FFFF' }}>
          {truncateText(title, 60)}
        </Typography>

        <Typography component="h2" sx={{ fontSize: '16px', fontWeight: 400, color: '#9CA3AF' }}>
          {truncateText(description, 80)}
        </Typography>

        <Box className="mt-2">
          <Link
            to={link}
            className="text-white-400 hover:text-white inline-flex items-center"
            state={{
              blog: {
                category,
                title,
                description,
                image
              },
              index
            }}
          >
            Read More
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </Box>
      </div>
    </div>
  );
};
export default InsightsCard;
